import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import ServiceNowConfigModal from "./ServiceNowConfigModal"
import servicenowLogo from "assets/images/connectors/servicenow-logo.png"

/**
 * ServiceNow card for the developer portal
 * Allows configuring a centralized ServiceNow connection for the entire platform
 */
const ServiceNowCard = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // TODO: Fetch the actual connection status from the API
  // const { data: snowConfig, isLoading } = useSnowConfig()
  const [connectionStatus, setConnectionStatus] = useState("configure_now")

  const handleConfigure = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSaveConfig = async (config) => {
    // TODO: Implement centralized configuration save
    // await saveSnowConfig(config)
    console.log("ServiceNow config saved:", config)
    setConnectionStatus("connected")
    setIsModalOpen(false)
  }

  return (
    <>
      <ApiConnectorCard
        serviceName={t("developer_portal:connectors.service_now.name")}
        description={t("developer_portal:connectors.service_now.description")}
        tag={t("developer_portal:connectors.service_now.tag")}
        status={connectionStatus}
        // TODO: temporary desactivate
        // onStatusClick={handleConfigure}
        logoSource={servicenowLogo}
        logoAlt="ServiceNow"
        fillIcon={true}
      />
      <ServiceNowConfigModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveConfig}
      />
    </>
  )
}

export default ServiceNowCard
